export const neutralVariantColorScale = {
    0: "#000000",
    5: "#091312",
    10: "#141D1C",
    15: "#1E2827",
    20: "#293231",
    25: "#343D3C",
    30: "#3F4948",
    35: "#4E5352",
    40: "#56605F",
    50: "#6F7978",
    60: "#899391",
    70: "#A3ADAC",
    80: "#BEC9C7",
    90: "#DAE5E3",
    95: "#E9F3F1",
    98: "#F2F9F8",
    99: "#F5FCFB",
    100: "#FFFFFF",
};
